import axios from "axios";

const { REACT_APP_BASE_URL } = process.env;

export const getPreSellers = async (token, results = 20, page = 1) => {
  try {
    const response = await axios.get(
      `${REACT_APP_BASE_URL}/sellers/pre-seller?results=${results}&page=${page}`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    return response;
  } catch (error) {
    const err = error?.response?.data?.error ?? {};
    const response =
      err?.type === "VALIDATION_ERROR"
        ? err.errors[0]?.msg
        : err?.message ?? "Error en la petición";

    return Promise.reject(response);
  }
};
